import "./Button.css";

const Button = ({ className, ...props }) => {
  return <button className={`btn-default ${className}`} {...props}></button>;
};

export default Button;
